import React, {
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import {
  useFormContext,
} from 'react-hook-form';
import {
  isEmptyString,
} from '@populateui/utils';
import SingleDatePicker from 'core/components/DateTimePicker/SingleDatePicker';
import dayjs, {
  Dayjs,
  getOrgNow,
} from 'utils/dayjs';
import {
  formatDate,
} from 'utils/date';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';

export default function DateField({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  const isSignatureDate = field.type === 'signatureDate';
  const { watch } = useFormContext();
  const fieldKey = field?.id ?? '';
  const fieldData = watch(fieldKey);
  const fieldValue = fieldData?.value as string | undefined;

  const updateDate = useCallback((date: Dayjs | null) => {
    const formatted = !isNil(date) ? formatDate(date.toDate()) : '';
    onChange({ ...value, value: formatted });
  }, [onChange, value]);

  useEffect(() => {
    if (isSignatureDate && isEmptyString(fieldValue)) {
      updateDate(getOrgNow());
    }
  }, [fieldValue, isSignatureDate, updateDate]);

  const date = useMemo(
    () => (isEmptyString(fieldValue) ? null : dayjs(fieldValue)),
    [fieldValue],
  );

  return (
    <SingleDatePicker
      key={field.id}
      value={date}
      disabled={isSignatureDate}
      onChange={updateDate}
      error={!isSignatureDate && error}
      inputContainerClassName={clsx('w-full', { 'bg-[#e9edf4]': isSignatureDate })}
      showDateButtons={false}
    />
  );
}
